/**
 * Fait : le choix de la branche d'un fil — la liste déroulante qui bascule
 *   entre la branche initiale et les variantes nées des comparaisons. Ne
 *   s'affiche que s'il y a un choix à faire : une liste d'un seul élément
 *   n'est que du bruit.
 *
 * Ne fait pas : il ne charge rien et ne décide rien — le fil lui donne les
 *   branches et reprend la main à chaque bascule.
 */

import type { BrancheVue } from './api-fil.ts';

export function SelecteurDeBranche({
  branches,
  brancheId,
  surBascule,
}: {
  readonly branches: readonly BrancheVue[];
  readonly brancheId: string | null;
  readonly surBascule: (brancheId: string) => void;
}) {
  if (branches.length <= 1) return null;

  return (
    <label>
      Branche{' '}
      <select
        data-role="branches"
        value={brancheId ?? ''}
        onChange={(evenement) => {
          surBascule(evenement.target.value);
        }}
      >
        {branches.map((branche, rang) => (
          <option key={branche.id} value={branche.id}>
            {rang === 0 ? 'Branche initiale' : `Branche ${String(rang + 1)}`}
          </option>
        ))}
      </select>
    </label>
  );
}
